const CreditCardNavIcon = ({
  className = 'stroke-green-800'
}: {
  className?: string
}) => (
  <svg
    width='24'
    height='28'
    viewBox='0 0 24 28'
    className={className}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M21 23.9408H3C1.895 23.9408 1 22.9522 1 21.7317V6.26838C1 5.04788 1.895 4.05933 3 4.05933H16H21C22.105 4.05933 23 5.04788 23 6.26838V21.7317C23 22.9522 22.105 23.9408 21 23.9408Z'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M1 8.47742H23'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M1 12.8955H23'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M5 18.4182H10'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M18 18.4182H19'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </svg>
)

export default CreditCardNavIcon
